module.exports = __webpack_public_path__ + "static/img/WarmPlate (12).d4fa5ea2.png";